import { async_command_dispatcher } from "@/api/client"
import { KitDigitalSenderInterface } from "../app/KitDigitalSenderInterface"

class HubspotKitDigitalDispatcher implements KitDigitalSenderInterface {
  async send(keyPath: string): Promise<unknown> {
    try {
      const res = await async_command_dispatcher.dispatch_with_result(
        "send_kit_digital_to_hubspot",
        { path: keyPath },
        1000
      )

      if (res && res.output && res.output.error) throw new Error(res.output.error)
      if (res && res.error) throw new Error(res.error)

      return (res && res.output) ? res.output : res
    } catch (error) {
      const msg = error && (error as any).message ? (error as any).message : String(error)
      throw new Error("HubspotKitDigitalDispatcher: " + msg)
    }
  }
}

export { HubspotKitDigitalDispatcher }
